import { bulkPricing } from './bulk-pricing.i18n';

export const en = {
  bulkPricing,
};
